import React from 'react';

type SimpleProgressBarProps = {
  value: number;
  max: number;
  className?: string;
};

export const SimpleProgressBar: React.FC<SimpleProgressBarProps> = ({
  value,
  max,
  className = ''
}) => {
  const percent = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  let progressColor = 'bg-primary-blue';
  if (percent >= 98) {
    progressColor = 'bg-accent-red';
  } else if (percent > 80) {
    progressColor = 'bg-accent-amber';
  }
  return (
    <div className={`h-2 w-full overflow-hidden rounded bg-primary-gray ${className}`}>
      <div
        className={`h-full rounded transition-all duration-300 ${progressColor}`}
        style={{ width: `${percent}%` }}
      />
    </div>
  );
};
